import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-privacy-policy',
  templateUrl: './master-privacy-policy.component.html',
  styleUrls: ['./master-privacy-policy.component.scss']
})
export class MasterPrivacyPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/master-privacy-policy/master-privacy-policy.component.ts